// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_eQ","advertDetailContactItem__link":"c-n_eR"};